<template>
  <div class="flex items-center justify-between pb-[2.4rem]">
    <h2 class="font-medium text-black md:text-[2.4rem] sm:text-[1.8rem]">{{ title }}</h2>
    <p v-if="stepInfo" class="text-black md:text-[1.6rem] sm:text-[1.8rem]">
      {{ stepInfo.current }}/{{ stepInfo.total }}
    </p>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
  name: 'AppointmentTitle',
  setup() {
    const route = useRoute();
    const { t } = useI18n();

    const title = computed(() => {
      switch (route.name) {
        case 'CheckoutPrebookSuccess':
          return t('Confirm your reservation');
        default:
          return t('Data regarding the appointment');
      }
    });

    const stepInfo = computed(() => null);

    return {
      title,
      stepInfo,
    };
  }
};
</script>

<style scoped>

</style>
